import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FechaDestinoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='FECHA DESTINO' htmlFor='filtro-fechaDestino' xs={4} xl={5} alignRightAt='xs' />
      <Col xs={8} xl={7}>
        <Field name='fechaDestino'>
          {({ field }) => (
            <Form.InputDate
              {...field}
              id='filtro-fechaDestino'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaDestinoFormGroup)
